<template>
  <el-dialog
    class="
      panel-dialog
    "
    :visible.sync="modal.open"
    :close-on-click-modal="false"
    :z-index="2002">
    <div
      slot="title"
      class="
        dialog-title
      ">
      <h4>
        {{ modal.title }}
      </h4>
    </div>
    <div class="page-content">
      <article>
        <p>
          <b>ช่วงเวลา</b>
        </p>
        <div>
          <label>
            กรองวันที่จาก
          </label>
          <div class="btn-group">
            <el-button
              v-for="
                ({ label, value }, i) in common.dateType
              "
              :key="i"
              :type="
                form.dateType == value ? 'sc-asset' : ''
              "
              :disabled="
                disabled
              "
              @click="
                () => form.dateType = value
              ">
              {{ label }}
            </el-button>
          </div>
        </div>
        <div>
          <label>
            ช่วงเวลา
          </label>
          <div class="date-group">
            <el-date-picker
              :key="
                'วันที่เริ่มต้น'
              "
              v-model="
                form.dateStart
              "
              class="date-input"
              type="date"
              :disabled="
                disabled || form.docs.length > 0
              "
              :picker-options="
                pickerOptions.start
              "
            />
            <span class="date-separator">
              ถึง
            </span>
            <el-date-picker
              v-model="
                form.dateStop
              "
              class="date-input"
              type="date"
              :disabled="
                disabled || form.docs.length > 0
              "
              :placeholder="
                'วันที่สิ้นสุด'
              "
              :picker-options="
                pickerOptions.stop
              "
            />
          </div>
        </div>
      </article>
      <hr />
      <article>
        <p>
          <b>แพ็กเกจ & สถานะ</b>
        </p>
        <div>
          <label>
            หมวดหมู่
          </label>
          <div class="btn-group">
            <el-button
              v-for="
                ({ label, value }, i) in common.groupName
              "
              :key="i"
              :type="
                form.groupName == value ? 'sc-asset' : ''
              "
              :disabled="
                disabled
              "
              @click="
                () => form.groupName = value
              ">
              {{ label }}
            </el-button>
          </div>
        </div>
        <div>
          <label>
            ประเภท
          </label>
          <div class="btn-group">
            <el-button
              v-for="
                ({ label, value }, i) in common.pkg
              "
              :key="i"
              :type="
                form.pkg == value ? 'sc-asset' : ''
              "
              :disabled="
                disabled || isPkgDisabled(value)
              "
              @click="
                () => form.pkg = value
              ">
              {{ label }}
            </el-button>
          </div>
        </div>
        <div>
          <label>
            สถานะ
          </label>
          <div class="btn-group">
            <el-button
              v-for="
                ({ label, value }, i) in common.status
              "
              :key="i"
              :type="
                form.status == value ? 'sc-asset' : ''
              "
              :disabled="
                disabled
              "
              @click="
                () => form.status = value
              ">
              {{ label }}
            </el-button>
          </div>
        </div>
        <div>
          <label>
            กลุ่มบริษัท
          </label>
          <div class="btn-group">
            <el-button
              v-for="
                ({ label, value }, i) in common.seller
              "
              :key="i"
              :type="
                form.seller == value ? 'sc-asset' : ''
              "
              :disabled="
                disabled
              "
              @click="
                () => form.seller = value
              ">
              {{ label }}
            </el-button>
          </div>
        </div>
      </article>
      <hr />
      <article>
        <p>
          <b>ใบเสร็จ & อื่น ๆ</b>
        </p>
        <div>
          <label>
            ประเภทใบเสร็จ
          </label>
          <div
            class="
              btn-group cols-2
            ">
            <el-button
              v-for="
                ({ label, value }, i) in common.receipt
              "
              :key="i"
              :type="
                form.receipt == value ? 'sc-asset' : ''
              "
              :disabled="
                disabled
              "
              @click="
                () => form.receipt = value
              ">
              {{ label }}
            </el-button>
          </div>
        </div>
        <div>
          <label>
            Morning Coin
          </label>
          <p>
            <el-switch
              v-model="
                form.usedCoin
              "
              :disabled="
                disabled
              "
              active-text="
                เฉพาะที่ใช้ MNC
              "
              inactive-text="
                ทั้งหมด
              "
            />
          </p>
        </div>
        <div>
          <div class="doc-label">
            <label>
              เลขที่เอกสาร ({{ (form.docs || []).length }}/10)
            </label>
            <el-button
              type="danger"
              size="mini"
              round
              :disabled="
                disabled || !form.docs || !form.docs.length
              "
              @click="
                clearDocs
              ">
              ล้าง
            </el-button>
          </div>
          <div class="doc-textarea">
            <el-tag
              v-for="
                (doc, i) in form.docs
              "
              :key="doc"
              :closable="
                !disabled
              "
              :disable-transitions="
                false
              "
              @close="
                () => removeDoc(i)
              ">
              {{ doc }}
            </el-tag>
            <input
              type="text"
              class="doc-textarea-input"
              v-model="
                docInput
              "
              :disabled="
                disabled || docsLimitReached
              "
              :placeholder="
                'ระบุเลขที่เอกสาร'
              "
              @keydown.enter.prevent="
                addDoc
              "
            />
            <el-button
              type="sc-asset"
              circle
              size="small"
              icon="el-icon-plus"
              :disabled="
                disabled || docsLimitReached
              "
              @click="
                addDoc
              "
            />
          </div>
        </div>
      </article>
    </div>
    <div
      slot="footer"
      class="
        dialog-footer
      ">
      <el-button
        type="sc-asset"
        :disabled="
          disabled
        "
        @click="
          () => select(form)
        ">
        ค้นหา
      </el-button>
      <el-button
        type="info"
        :disabled="
          disabled
        "
        @click="
          resetForm
        ">
        ล้างตัวกรอง
      </el-button>
    </div>
  </el-dialog>
</template>

<script lang="js">

// Common
import { SubsReportCommon as Common } from '@/features/subscribers-report/common/subs-report.common'
import { SubsReportFilterCommon as FilterCommon } from '@/features/subscribers-report/common/subs-report-filter.common'

// Filter common
const { filter } = FilterCommon

export default {
  props: {
    open: {
      type: Boolean,
      default: false
    },
    selected: {
      type: Object,
      default: () => filter()
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      modal: {
        open  : this.open,
        title : 'ตัวกรองรายงาน'
      },
      form: filter(),
      docInput: '',
    }
  },
  computed: {
    common: () => Common,
    pickerOptions() {

      // Picker Options
      const options = {}

      // Form props
      const { dateStart, dateStop } = this.form

      // Start options
      options.start = {
        disabledDate: (time) => (
          FilterCommon.dateMax(time, dateStop)
        )
      }

      // Stop options
      options.stop = {
        disabledDate: (time) => (
          FilterCommon.dateMin(time, dateStart)
        )
      }

      return options
    },
    docsLimitReached() {
      return (
        this.form.docs && this.form.docs.length >= 10
      )
    },
    isUnsubscribed() {
      return (
        this.form.status === 'SUBS_UNSUBSCRIBED'
      )
    },
  },
  watch: {
    open(open) {

      // Open modal
      this.modal.open = open

      // Restore Form
      if (open) {
        this.initForm()
      }
    },
    'modal.open': function handleModalOpenChange(open) {
      this.$emit(
        'update:open', open
      )
    },
    'form.dateStart': function handleDateStartChange(date) {

      // Reset On Clear
      if (!date) {
        this.form.dateStart = FilterCommon.startOfToday()
        return
      }

      // Form props
      const { dateStop } = this.form

      // Start date validation
      const valid = (
        dateStop && FilterCommon.dateMin(
          new Date(dateStop), date
        )
      )

      // Validate Date
      if (date && valid) {
        this.form.dateStop = null
      }
    },
    'form.dateStop': function handleDateStopChange(date) {

      // Reset On Clear
      if (!date) {
        this.form.dateStop = FilterCommon.endOfToday()
        return
      }

      // Form props
      const { dateStart } = this.form

      // Start date validation
      const valid = (
        dateStart && FilterCommon.dateMax(
          new Date(dateStart), date
        )
      )

      // Validate Date
      if (date && valid) {
        this.form.dateStart = null
      }
    },
    'form.status': function handleFormStatusChange(status, prevStatus) {

      // Unsubscribed
      const isUnsub = (
        status === 'SUBS_UNSUBSCRIBED'
      )

      // Unsubscribed selected
      const isSelected = (
        isUnsub && this.form.pkg !== 'PKG_SUBSCRIBE'
      )

      // Unsubscribed changed
      const isChanged = (
        !isUnsub && prevStatus === 'SUBS_UNSUBSCRIBED'
      )

      // Force Pkg to Subscribe
      if (isSelected) {
        this.form.pkg = 'PKG_SUBSCRIBE'
      }

      // Reset Pkg from Unsubscribed
      else if (isChanged) {
        this.form.pkg = null
      }
    }
  },
  created() {
    this.initForm()
  },
  methods: {
    initForm() {

      // Init Form
      if (this.selected) {
        this.form = Object.assign(
          filter(), this.selected
        )
      }

      // Init Date
      const { dateStart, dateStop } = this.form

      // Validate Date
      if (!dateStart) {
        this.form.dateStart = FilterCommon.startOfToday()
      }

      // Validate Date
      if (!dateStop) {
        this.form.dateStop = FilterCommon.endOfToday()
      }
    },
    isPkgDisabled(value) {
      return (
        this.isUnsubscribed && value !== 'PKG_SUBSCRIBE'
      )
    },
    select(item) {
      
      // Emit selected
      this.$emit(
        'select', item
      )
      
      // Open modal
      this.modal.open = false
    },
    addDoc() {

      // Trim Input
      const doc = this.docInput.trim()

      // Validate Input
      if (!doc) return
      if (!this.form.docs) this.form.docs = []

      // Validate Limit
      if (this.docsLimitReached) return

      // Validate Duplicate
      if (this.form.docs.includes(doc)) return

      // Append Doc
      this.form.docs.push(doc)

      // Reset Input
      this.docInput = ''
    },
    removeDoc(i) {
      this.form.docs.splice(i, 1)
    },
    clearDocs() {
      this.form.docs = []
    },
    resetForm() {
      this.form = FilterCommon.filter()
    }
  }
}
</script>

<style lang="css" scoped>

.panel-dialog >>> .el-dialog {
  max-width: 768px;
}

.page-content {
  padding    : var(--size-lg);
  padding-top: var(--size-sm);
}

.page-content article {
  display: grid;
  gap    : var(--size-md);
}

.btn-group {
  display   : flex;
  gap       : var(--size-xs);
  flex-wrap : wrap;
}

.date-group {
  display     : flex;
  align-items : center;
  gap         : var(--size-sm);
}

.date-input {
  width : 100%;
  flex  : 1;
}

.date-separator {
  flex: none;
}

.doc-label {
  display        : flex;
  align-items    : center;
  justify-content: space-between;
  margin-bottom  : var(--size-xs);
}

.doc-textarea {
  display       : flex;
  flex-wrap     : wrap;
  align-content : flex-start;
  align-items   : center;
  gap           : var(--size-xs);
  padding       : var(--size-sm);
  border        : var(--border);
  border-radius : 4px;
}

.doc-textarea-input {
  flex        : 1;
  min-width   : 120px;
  border      : none;
  outline     : none;
  background  : transparent;
  font-size   : inherit;
  font-family : inherit;
}

.el-tag {
  font-size       : 1rem;
  display         : flex;
  align-items     : center;
  justify-content : center;
  height          : 40px;
}

.el-tag >>> i.el-icon-close {
  margin-top: .25rem;
}

.dialog-footer {
  display        : flex;
  gap            : var(--size-sm);
  justify-content: start;
  padding-top    : var(--size-sm);
}

@media (max-width: 768px) {
  
  .date-group {
    flex-direction  : column;
    align-items     : stretch;
  }
  .date-group .date-separator {
    display: none;
  }
}

</style>